/** Filtro / agrupación del listado de reuniones (puro). */

export function meetingSearchHaystack(row = {}) {
  return [
    row.title,
    row.customerName,
    row.meetingDate,
    row.attendeeNames,
    row.clientContactNames,
    row.status,
  ]
    .map((v) => String(v || "").toLowerCase())
    .join(" ");
}

export function filterMeetingSessions(
  rows = [],
  { query = "", customer = "", status = "" } = {},
) {
  const q = String(query || "")
    .trim()
    .toLowerCase();
  const customerFilter = String(customer || "").trim();
  const statusFilter = String(status || "").trim();

  return (Array.isArray(rows) ? rows : []).filter((row) => {
    if (statusFilter && String(row.status || "") !== statusFilter) return false;
    if (customerFilter) {
      const name = String(row.customerName || "").trim();
      if (name !== customerFilter) return false;
    }
    if (q && !meetingSearchHaystack(row).includes(q)) return false;
    return true;
  });
}

export function uniqueMeetingCustomers(rows = []) {
  const set = new Set();
  for (const row of Array.isArray(rows) ? rows : []) {
    const name = String(row.customerName || "").trim();
    if (name) set.add(name);
  }
  return [...set].sort((a, b) =>
    a.localeCompare(b, "es", { sensitivity: "base" }),
  );
}

/** Agrupa por cliente; sin cliente → "". Orden: clientes A–Z, sin cliente al final. */
export function groupMeetingsByCustomer(rows = []) {
  const map = new Map();
  for (const row of Array.isArray(rows) ? rows : []) {
    const key = String(row.customerName || "").trim();
    if (!map.has(key)) map.set(key, []);
    map.get(key).push(row);
  }
  const keys = [...map.keys()].sort((a, b) => {
    if (!a && b) return 1;
    if (a && !b) return -1;
    return a.localeCompare(b, "es", { sensitivity: "base" });
  });
  return keys.map((customerName) => ({
    customerName,
    meetings: map.get(customerName),
  }));
}

export function meetingPreviewHeadline(row) {
  if (!row) return "";
  const summary = row.summary;
  if (summary && typeof summary === "object") {
    return String(summary.headline || summary.rawSummary || "").trim();
  }
  return String(row.summaryPreview || "").trim();
}

/**
 * Fecha de reunión para listado (ISO YYYY-MM-DD → locale).
 * @param {string|Date|null|undefined} value
 * @param {string} [locale="es-ES"]
 */
export function formatMeetingListDate(value, locale = "es-ES") {
  if (value == null || value === "") return "";
  const raw = String(value).trim();
  const m = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  let date;
  if (m) {
    date = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
  } else {
    date = new Date(raw);
  }
  if (Number.isNaN(date.getTime())) return raw;
  const loc = String(locale || "es-ES")
    .toLowerCase()
    .startsWith("en")
    ? "en-GB"
    : String(locale || "es-ES")
          .toLowerCase()
          .startsWith("es")
      ? "es-ES"
      : locale || "es-ES";
  return date.toLocaleDateString(loc, {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
}
